export const MathConst = {
  H_PI: Math.PI * 0.5,
  PI_2: Math.PI * 2,
};
